import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { AddDomainRequest, CNameConfiguration } from '@models/email/emailDomain';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmailCampaignDnsService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getListDomainCampaigns(): Observable<CNameConfiguration[]> {
    const suffixUrl = 'email/domain/campaigns';
    const url = this.baseUrl + suffixUrl;
    return this.http.get<Response[]>(url).pipe(
      map(data => {
        if (data) {
          return data.map(d => CNameConfiguration.deserialize(d));
        }
      })
    );
  }

  getDnsCampaign(idDomain: number): Observable<CNameConfiguration> {
    const suffixUrl = 'email/domain/campaigns/' + idDomain;
    const url = this.baseUrl + suffixUrl;
    return this.http.get<Response>(url).pipe(
      map(data => {
        return CNameConfiguration.deserialize(data);
      })
    );
  }

  deleteDomainCampaign(idDomain: number) {
    const suffixUrl = 'email/domain/campaigns/' + idDomain;
    const url = this.baseUrl + suffixUrl;
    return this.http.delete(url);
  }

  verifyDnsCampaign(idDomain: number) {
    const suffixUrl = 'email/domain/campaigns/' + idDomain + '/verify';
    const url = this.baseUrl + suffixUrl;
    return this.http.post(url, { responseType: 'text' as 'json' });
  }

  addNewDomainCampaign(request: AddDomainRequest): Observable<CNameConfiguration> {
    const suffixUrl = 'email/domain/campaigns';
    const url = this.baseUrl + suffixUrl;
    return this.http.post(url, request).pipe(map(data => CNameConfiguration.deserialize(data)));
  }
}
